<template>
  <div class="modal fade" id="editModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-bottom-0">
          <h4>Edit Bill item details</h4>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Income Type</label>
                <select
                    v-model="localItem.incomeTypeId"
                    class="form-control selectpicker bg-white"
                    title="Select Income Type"
                    data-live-search="true"
                >
                  <option
                      v-for="(type, index) in incomeTypes"
                      :key="index"
                      :value="type.incomeTypeId"
                  >
                    {{ type.incomeTypeDescription }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Account Name</label>
                <select
                    v-model="localItem.accountNo"
                    class="form-control selectpicker bg-white"
                    title="Select Account"
                    data-live-search="true"
                >
                  <option
                      v-for="(account, index) in accounts"
                      :key="index"
                      :value="account.accountNo"
                  >
                    {{ account.accountDesc }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Sub County</label>
                <select
                    v-model="localItem.subCountyID"
                    class="form-control selectpicker bg-white"
                    title="Select Sub County"
                    data-live-search="true"
                >
                  <option
                      v-for="(sub, index) in subCounties"
                      :key="index"
                      :value="sub.subCountyID"
                  >
                    {{ sub.subCountyName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Ward</label>
                <select
                    v-model="localItem.wardID"
                    class="form-control selectpicker bg-white"
                    title="Select Ward"
                    data-live-search="true"
                >
                  <option
                      v-for="(ward, index) in wards"
                      :key="index"
                      :value="ward.wardID"
                  >
                    {{ ward.wardName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Details</label>
                <textarea
                    v-model="localItem.details"
                    cols="30"
                    rows="3"
                    placeholder="More details"
                    class="form-control"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex">
          <button @click="handleSave" class="btn btn-primary flex-grow-1">Done</button>
          <button class="btn btn-light" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditBillModal',

  props: {
    billItem: {
      type: Object,
      default: () => ({})
    },
    incomeTypes: {
      type: Array,
      default: () => []
    },
    accounts: {
      type: Array,
      default: () => []
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    wards: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      localItem: { ...this.billItem }
    }
  },

  watch: {
    billItem: {
      handler(newVal) {
        this.localItem = { ...newVal }
      },
      deep: true
    }
  },

  methods: {
    handleSave() {
      this.$emit('save-bill-item', this.localItem)
    }
  }
}
</script>